import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-annual-study-hours',
  templateUrl: './annual-study-hours.component.html',
  styleUrls: ['./annual-study-hours.component.css']
})
export class AnnualStudyHoursComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
